import React, { useState, Fragment, useEffect } from 'react'
import injectStyles from 'react-jss'

import { PickupHeader } from './PickupHeader'
import PickupBrief from '../PickupBrief'
import PickupData from './PickupData'
import { usePickupContext } from '../context/PickupContext'
import { PickupHeaderWrapper } from './style'
import { urlGet } from 'Utils/URL'
import { isBriefPage } from '../utils'
import { PickupAll } from './PickupAll'
import PickupNav from '../PickupNav'

const styles = {
  searchInputClassName: {
    '@global input': {
      backgroundColor: 'white',
    },
  },
}

const View = ({ classes }) => {
  const {
    pickupContextState,
    setSelectedCampaigns,
    setSelectedPreset,
  } = usePickupContext()
  const {
    selectedBrandAmbassadors,
    selectedCampaigns,
    selectedClients,
    cityId,
    pickupType,
  } = pickupContextState

  // Fake state to trigger a rerender. Starting to dislike hooks and React 😠
  var [, setDummyState] = useState()
  var rerender = () => setDummyState(new Date())

  var [searchText, setSearchText] = useState(urlGet('search') || '')

  useEffect(() => {
    if (pickupType === 'brief') {
      setSelectedCampaigns(undefined)
      setSelectedPreset(0)
    }
  }, [pickupType])

  // Wraps a function that after that function runs triggers a rerender
  const rerenderAfter = func => (...args) => {
    func(...args)
    rerender()
  }

  return (
    <PickupHeaderWrapper>
      <PickupData
        cityId={cityId}
        brandAmbassadorIds={
          selectedBrandAmbassadors
            ? selectedBrandAmbassadors.map(o => o.id)
            : null
        }
        campaignIds={
          pickupType === 'all'
            ? selectedCampaigns
              ? selectedCampaigns.map(o => o.id)
              : null
            : null
        }
        clientIds={selectedClients ? selectedClients.map(o => o.id) : null}
        searchText={searchText}
        pickupType={pickupType}
      >
        <InnerView
          classes={classes}
          setSearchText={setSearchText}
          rerenderAfter={rerenderAfter}
          searchText={searchText}
        />
      </PickupData>
    </PickupHeaderWrapper>
  )
}

const InnerView = ({
  classes,
  setSearchText,
  rerenderAfter,
  searchText,
  givenOutCodes,
  availableCodes,
  updateLocalInventoryState,
  missions,
  isFetching,
  ...otherProps
}) => {
  const { pickupContextState } = usePickupContext()
  const { brandAmbassadors, pickupType } = pickupContextState
  return (
    <Fragment>
      <PickupNav />
      <PickupHeader
        rerenderAfter={rerenderAfter}
        classes={classes}
        setSearchText={setSearchText}
        searchText={searchText}
        missions={missions}
        pickupType={pickupType}
        givenOutCodes={givenOutCodes}
        availableCodes={availableCodes}
      />
      {isBriefPage(pickupType) ? (
        <PickupBrief
          brandAmbassadors={brandAmbassadors}
          missions={missions}
          givenOutCodes={givenOutCodes}
          isFetching={isFetching}
        />
      ) : (
        <PickupAll
          givenOutCodes={givenOutCodes}
          availableCodes={availableCodes}
          missions={missions}
          updateLocalInventoryState={updateLocalInventoryState}
          isFetching={isFetching}
          {...otherProps}
        />
      )}
    </Fragment>
  )
}

export default injectStyles(styles)(View)
